<iframe id="FrameID" [src]="urlSafe" width="" height=""></iframe>
